// CTV-863: a video's length as a badge reads, "0:30" or "12:05". Rounded to
// the nearest second, since a 30.04s commercial is a thirty.

export function formatDuration(seconds: number): string | null {
  if (!Number.isFinite(seconds) || seconds < 0) return null;
  const whole = Math.round(seconds);
  const m = Math.floor(whole / 60);
  const s = whole % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}
